import { CandleInterval, CandlePoint } from "../../candle.types";

export const RECONNECT_DELAYS_MS = [2_000, 5_000, 10_000, 20_000, 30_000];

export function emptyCandle(
  startTime: number,
  price: string,
  volume = "0"
): CandlePoint {
  return {
    startTime,
    openPrice: price,
    highPrice: price,
    lowPrice: price,
    closePrice: price,
    volume,
  };
}

export function intervalToKucoinWsSuffix(interval: CandleInterval): string {
  switch (interval) {
    case "1m":
      return "1min";
    case "5m":
      return "5min";
    case "15m":
      return "15min";
    case "30m":
      return "30min";
    case "1h":
      return "1hour";
    case "4h":
      return "4hour";
    case "1d":
      return "1day";
  }
}

